export default __webpack_public_path__ + "static/media/c_mobile_dr_05.4b775048.png";